import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Avatar from '../Avatar';
import { Tooltip } from '@material-ui/core';

const BucketImageUpload = ({
    onBucketAvatarChange,
    picture,
    classes,
    bucket,
}) => {
    const onBucketImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            const avatar = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(avatar);
            // clear input value
            event.target.value = '';
            onBucketAvatarChange(avatar, bucket.id);
        }
    };

    return (
        <React.Fragment>
            <Tooltip title="Upload avatar">
                <label
                    htmlFor={`bucket-avatar-input-${bucket.id}`}
                    className={classes.label}
                >
                    <Avatar
                        className={classes.picture}
                        src={picture}
                        imgProps={{
                            onError: e => {
                                e.target.src = '/assets/project_icon.svg';
                            },
                        }}
                        alt="bucket-picture"
                    />
                    <Avatar className={classes.icon}>
                        <i className="material-icons">photo_camera</i>
                    </Avatar>
                </label>
            </Tooltip>
            <input
                className={classes.input}
                accept="image/*"
                id={`bucket-avatar-input-${bucket.id}`}
                onChange={onBucketImageChange}
                type="file"
            />
        </React.Fragment>
    );
};

BucketImageUpload.propTypes = {
    onBucketAvatarChange: PropTypes.func.isRequired,
    picture: PropTypes.string.isRequired,
    classes: PropTypes.object,
    bucket: PropTypes.object.isRequired,
};

const style = ({ spacing, palette }) => ({
    label: {
        position: 'relative',
        '&:hover': {
            '& $icon': {
                visibility: 'visible',
            },
        },
    },
    picture: {
        borderRadius: '4px',
        width: '48px',
        height: '48px',
    },
    icon: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        left: 0,
        borderRadius: '4px',
        width: '48px',
        height: '48px',
        background: palette.background.gray2Color,
        visibility: 'hidden',
    },
    input: {
        display: 'none',
    },
});

export default injectSheet(style)(BucketImageUpload);



// WEBPACK FOOTER //
// ./src/components/bucket/BucketImageUpload.js